export const FETCHING_CLIENTS_INVOICES = 'FETCHING_CLIENTS_INVOICES';
export const FETCHING_PARTNERS_INVOICES = 'FETCHING_PARTNERS_INVOICES';
export const FETCHING_ALL_CLIENTS_INVOICES = 'FETCHING_ALL_CLIENTS_INVOICES';
export const FETCHING_ALL_PARTNERS_INVOICES = 'FETCHING_ALL_PARTNERS_INVOICES';
export const FETCHING_PARTNER_LINES = 'FETCHING_PARTNER_LINES';
export const MARKINGPAID_PARTNER_INVOICE = 'MARKINGPAID_PARTNER_INVOICE';
